import React, { useEffect, useState } from "react";
import { validate, validateEmail, validatePassword, validatePhone } from "../../../../utils";
function Input(props) {
  const { img, label, name, handleChange, value, submit, required,validation } = props;
  const [error, setError] = useState(false);
 
  const onChange = (event) => {
    const { name, value } = event.target
    // console.log("validateEmail(value)", validateEmail(value));
    // console.log("validatePassword(value)", validatePassword(value));
    // console.log(value);
    



    handleChange(event)
  }


  useEffect(() => {
    if (submit) {
      // console.log(validation);
      
      if (validation === "email") {
        setError(!validateEmail(value,required))
      }
      else if (validation === "phone") {
        setError(!validatePhone(value,required))
      }
      else if (validation === "password") {
        setError(!validatePassword(value))
      }
      else if (validation === "required"){
        setError(typeof value === 'string' && value.trim().length === 0);
        // console.log( typeof value === 'string' && value.trim().length === 0);
        // console.log(value);
        
      }
    }
  }, [submit])
  return (
    <>
    <div>
      <span className="det-label">
        {img!=="" ?
          <img
            src={require(`../../../../assets/DigitalMarketing/image/customer/${img}.png`)}
            alt="i"
          /> : ''}
        {label}
      </span>
      {name === "description" ?
        <textarea rows={20}  cols={10} placeholder="Empty" style={{ border: error && submit ? "1px solid red" : "" }}  className="textarea-custom" value={value} name={name} onChange={onChange} />
        :
        <input type="text" placeholder="Empty" style={{ border: error && submit ? "1px solid red" : "" }} className="text-custom" value={value} name={name} onChange={onChange} />

      }
      </div>
      {error&& validation==="password" &&
      <>
      <p style={{textAlign:"end",marginBottom:"0",fontSize:"12px",color:"red"}}>minimum 8 characters Required</p>
      </>
      }
    </>
  );
}

export default React.memo(Input);
